import React, { useRef, useEffect } from 'react';
import Footer from '../components/Footer';
import '../App.css'; // Custom CSS

const AboutUs = ({ setPage }) => {
    const sectionRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const section = sectionRef.current;
            if (!section) return;
            const rect = section.getBoundingClientRect();
            if (rect.top < window.innerHeight) {
                section.classList.add('visible');
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Trigger on mount
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>
            {/* <Navbar setPage={setPage} /> */}

            {/* Cover Image */}
            <div className="about-cover">
                <img
                    src="/images/about us.png"
                    alt="About Cover"
                    className="about-cover-image"
                />
                <div className="about-cover-text">
                    <h1>About Us</h1>
                </div>
            </div>

            {/* Main Content */}
            <section className="mcd-about-section" ref={sectionRef}>
                <div className="mcd-container-about">
                     {/* Meet Our Ship Management Team Banner */}
                    <div className="ship-team-banner-container">
                        {/* Hero Ship Background Header */}
                        <div className="ship-team-hero">
                            <img src="/images/shipmanage.webp" alt="Ship Management" className="ship-team-bg-img" />
                            <div className="ship-team-hero-overlay"></div>

                            {/* Decorative Corner Accents */}
                            <div className="accent-badge top-left"></div>
                            <div className="accent-badge middle-right"></div>

                            <div className="ship-team-title-box">
                                <span className="ship-team-subtitle">MEET OUR</span>
                                <h2 className="ship-team-title">SHIP MANAGEMENT</h2>
                                <h2 className="ship-team-title highlight">TEAM</h2>
                            </div>
                        </div>

                        {/* Dark Card Overlay with Glow Gradient Border */}
                        <div className="ship-team-card-wrapper">
                            <div className="ship-team-dark-card">
                                <div className="accent-badge bottom-left"></div>

                                <div className="ship-team-members-grid">
                                    {/* Member 1: Punsara Aravinda */}
                                    <div className="ship-team-member">
                                        <div className="ship-member-avatar-container">
                                            <img src="/images/punsara.webp" alt="Punsara Aravinda" className="ship-member-avatar" />
                                        </div>
                                        <h3 className="ship-member-name">PUNSARA ARAVINDA</h3>
                                        <p className="ship-member-role">MANAGING DIRECTOR</p>
                                    </div>

                                    {/* Member 2: Gayaru Fonseka */}
                                    <div className="ship-team-member">
                                        <div className="ship-member-avatar-container">
                                            <img src="/images/gyuru.webp" alt="Gayaru Fonseka" className="ship-member-avatar" />
                                        </div>
                                        <h3 className="ship-member-name">GAYARU FONSEKA</h3>
                                        <p className="ship-member-role">GENERAL MANAGER</p>
                                    </div>
                                </div>

                                {/* Card Footer Link */}
                                <div className="ship-team-card-footer">
                                    <span>www.bluewavesshipmanagement.com</span>
                                </div>
                            </div>
                        </div>
                    </div>  

                    {/* Who We Are Section */}
                    <section className="about-who-we-are">
                        <div className="about-two-column">
                            <div className="about-text">
                                <h2>Who We Are</h2>
                                <p>
                                    Welcome to Blue Waves Ship Management (PVT) LTD
                                </p>
                                <p>

                                    Based in Sri Lanka, Blue Waves Ship Management (PVT) LTD is a trusted name in global maritime ship management and facilitates services. We specialize in comprehensive ship management solutions, serving ship owners, charterers, and marine contractors around the world.
                                    Our commitment to safety, operational excellence, and environmental sustainability drives every aspect of our work. Backed by decades of collective industry experience, our team ensures that every vessel under our care operates at peak performance and in full compliance with international standards. At Blue Waves,
                                    we go beyond management—we build lasting partnerships for the long-term success of your fleet.
                                </p>
                            </div>
                            <div className="about-image">
                                <img src="/images/whoweare.webp" alt="Who We Are" />
                            </div>
                        </div>
                    </section>
                    

                    {/* Other Cards */}
                    <div className="mcd-about-grid">


                        <div className="mcd-about-card">
                            <h2>Our Vision</h2>
                            <p>To become the most trusted and efficient ship management partner in the region, driving value through operational excellence, innovation and unwavering commitment to global maritime standards.</p>
                        </div>
                        <div className="mcd-about-card">
                            <h2>Our Mission</h2>
                            <p>
                                To deliver end-to-end ship management solutions that maximize vessel performance and profitability.
                                To maintain the highest standards of safety, compliance and environmental responsibility.
                                To support our clients with responsive, transparent and reliable services.
                                To invest in human capital, building a competent and committed maritime workforce.</p>
                        </div>

                        <div className="mcd-about-card">
                            <h2>Core Principles</h2>
                            <ul>
                                <li>Lead by example</li>
                                <li>Foster ethical behavior and teamwork</li>
                                <li>Promote diversity and recognize excellence</li>
                                <li>Ensure well-being with proper resources and support</li>
                            </ul>
                        </div>

                        {/* <div className="mcd-about-card">
                            <h2>Certifications & Accreditations</h2>
                            <p>ISO 9001, ISO 14001, and OSHA 18001 certified—testament to our focus on quality, environmental responsibility, and safety.</p>
                        </div> */}
                    </div>

                   

                    <h2 className='ourteam'>Leadership & Organizational Structure</h2>
                    <div className="horizontal-tree-container">
                        <ul className="horizontal-tree">
                            <li>
                                <div className="tree-box md">Managing Director</div>
                                <ul>
                                    {/* Operations */}
                                    <li>
                                        <div className="tree-box">Operations</div>
                                        <ul>
                                            <li>
                                                <div className="tree-box">Technical</div>
                                                <ul>
                                                    <li><div className="tree-box">Vessel Superintendent</div></li>
                                                </ul>
                                            </li>
                                            <li>
                                                <div className="tree-box">Chartering</div>
                                                <ul>
                                                    <li><div className="tree-box">Vessel Coordinator</div></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>

                                    {/* Marketing */}
                                    <li>
                                        <div className="tree-box">Marketing</div>
                                        <ul>
                                            <li><div className="tree-box">Marketing Executive</div></li>
                                        </ul>
                                    </li>

                                    {/* Admin & Accounts */}
                                    <li>
                                        <div className="tree-box">Admin & Accounts</div>
                                        <ul>
                                            <li><div className="tree-box">Admin Manager</div></li>
                                            <li><div className="tree-box">Account Manager</div></li>
                                        </ul>
                                    </li>

                                    {/* HR */}
                                    <li>
                                        <div className="tree-box">HR</div>
                                        <ul>
                                            <li><div className="tree-box">HR Manager</div></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>


                
        </div>
            </section >

    <Footer />
        </div >
    );
};

export default AboutUs;
